import { TowingRecordRouteType, Time } from '../../../../common/types'
import { TowingRecordRoute } from './types'
import { format } from 'date-fns'

export function createNewRoute(routeType: TowingRecordRouteType, initialDate: boolean = true): TowingRecordRoute {
  const now = new Date()
  return {
    id: null,
    type: routeType,
    address: '',
    city: '',
    zipcode: '',
    description: '',
    coords: {
      lat: null,
      long: null,
    },
    ordering: 0,
    displayTimestampOnPrintables: false,
    displayFinishedTimestampOnPrintables: false,
    geolocated: false,
    arrivalDate: initialDate ? now : null,
    arrivalTime: initialDate ? ((format(now, 'HH:mm') as unknown) as Time) : null,
    finishedDate: initialDate ? now : null,
    finishedTime: initialDate ? ((format(now, 'HH:mm') as unknown) as Time) : null,
  }
}
